<template>
  <div class="home-page">
    <navbar :user="userInfo.userName" :headPic="headPic"></navbar>
    <router-view />
    <!-- <div class="fixed-btn" ref="fixedQrcode" @mouseover="onMouseOver" @mouseout="onMouseOut">
      <a class="fa-qrcode" href="javascript:void(0)" title="关注我们" style="display: inline-block;"></a>
      <div ref="wjQrcode" class="wj-bg-qrcode">
        <div class="wj-qrcode"></div>
        <div class="wj-message">
          <p>微信扫码跟踪数据</p>
          <p>意见反馈也扫这里</p>
        </div>
      </div>
    </div>
    <div class="guide-page" v-if="!guidePage">
      <div class="guide-pic"></div>
      <a href="javascript:;" class="confirm-btn" @click="handleConfirm">我知道了</a>
    </div>-->
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import axios from "axios";
import http from "../utils/http";
import QRCode from "qrcode";
import { mapActions, mapState } from "vuex";
import { MSG } from "../utils/utils";
export default {
  name: "Home",
  data() {
    return {
      interface: {
        getUser: `/survey/userInfo`
      },
      guidePage: 1
    };
  },
  mounted() {
    if (typeof this.userInfo.role === "undefined") {
      this.userInfo.role = "";
    }
    this.saveRole(this.userInfo.role);
    sessionStorage.setItem("relaunch", 1);
    // if (!window.localStorage.getItem("__attention__")) {
    //   this.setAttention(0);
    // }
    // if (!window.localStorage.getItem("__guide_page__1")) {
    //   this.guidePage = 0;
    // }

    // http
    //   .get(this.interface.getUser, {})
    //   .then(response => {
    //     const { code, data, message } = response;
    //     if (code === 1) {
    //       this.username = data.userName;
    //       window.initWmdaSdk && window.initWmdaSdk(data.uid);
    //       this.headPic =
    //         data.picture ||
    //         "//img.58cdn.com.cn/git/wuba-survey-m/img/user_pic.png";
    //       localStorage.setItem("survey-user", JSON.stringify(data));
    //       if (typeof data.role === "undefined") {
    //         data.role = "";
    //       }
    //       this.saveRole(data.role);
    //       sessionStorage.setItem("relaunch", 1);
    //     } else {
    //       MSG.error(message);
    //     }
    //   })
    //   .catch(error => {
    //     MSG.error(error);
    //   });
  },
  computed: {
    ...mapState({
      user: state => state.userInfo
    }),
    userInfo() {
      return this.user || {}
    },
    headPic() {
      return this.userInfo.picture || "//img.58cdn.com.cn/git/wuba-survey-m/img/user_pic.png"
    }
  },
  methods: {
    ...mapActions(["setAttention", "saveRole"]),
    handleConfirm() {
      this.guidePage = 1;
      window.localStorage.setItem("__guide_page__1", 1);
    }
  },
  components: {
    navbar: Navbar
  }
};
</script>

<style lang="scss">
.home-page {
  width: 100%;
  height: 100%;
}
html,
body {
  font: 14px/1.4 "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", "arial",
    "Tahoma", "SimSun", "sans-serif";
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  // min-height: 600px;
}
body,
dd,
dl,
dt,
h2,
h3,
h4,
h6,
li,
ol,
p,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
  -webkit-text-size-adjust: none;
}
body {
  overflow-x: hidden;
}
img {
  border: 0;
}
i,
h2,
h3,
h4,
h6 {
  font-style: normal;
}
a {
  cursor: pointer;
  text-decoration: none;
  color: #666;
}
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:focus {
  outline: none;
}
:visited {
  color: #999;
}
::-webkit-scrollbar {
  width: 3px;
  height: 6px;
}
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 6px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  -webkit-border-radius: 6px;
  background-color: #666;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  -webkit-border-radius: 6px;
  background-color: #666;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接:";
}
.ql-snow .ql-tooltip::before {
  content: "当前地址:";
}
.ql-snow .ql-tooltip a.ql-action::after {
  content: "编辑";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "确定";
  padding-right: 0px;
}
.ql-snow .ql-tooltip a.ql-remove::before {
  content: "删除";
}
.clear-fix {
  zoom: 1;
}
.clear-fix:after {
  display: block;
  clear: both;
  content: "";
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}

#app {
  width: 100%;
  height: 100%;
}

.el-select-dropdown {
  max-width: 540px;
}
.wj-bg-qrcode {
  background-image: url("../assets/qr-bg.png");
  background-size: contain;
  background-color: transparent;
  width: 120px;
  height: 165px;
  position: fixed;
  z-index: 1000;
  right: 15px;
  bottom: 30px;
  border-radius: 3px;
  .wj-qrcode {
    background-image: url("../assets/wx-qrcode.jpeg");
    background-size: contain;
    width: 110px;
    height: 110px;
    margin: 5px 5px 0 5px;
  }
  .wj-message {
    color: #fff;
    text-align: center;
    font-size: 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 13px;
  }
}
.fixed-btn {
  position: fixed;
  right: 20px;
  bottom: 40px;
  height: 40px;
  border: 1px solid #eee;
  background-color: white;
  font-size: 24px;
  z-index: 1040;
  -webkit-backface-visibility: hidden;
  .fa-qrcode {
    background-image: url("../assets/qrcode-logo.png");
    background-size: contain;
    width: 38px;
    height: 38px;
  }
}
.guide-page {
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  .guide-pic {
    background-image: url("../assets/pc_guide.png");
    width: 540px;
    height: 375px;
    background-size: cover;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  .confirm-btn {
    background: #ff552d;
    border-radius: 2px;
    width: 200px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    position: absolute;
    left: calc(50% - 100px);
    top: calc(50% + 250px);
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue